'use client'

import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'
import { OffMarketSignInModal } from './OffMarketSignInModal'

interface OffMarketGateContextValue {
  /** Call this to show the sign-in modal. Pass a redirect URL to navigate after sign-in. */
  requestAccess: () => void
}

const OffMarketGateContext = createContext<OffMarketGateContextValue>({
  requestAccess: () => {},
})

export function useOffMarketGate() {
  return useContext(OffMarketGateContext)
}

export function OffMarketGateProvider({ children }: { children: ReactNode }) {
  const [modalOpen, setModalOpen] = useState(false)

  const requestAccess = useCallback(() => {
    setModalOpen(true)
  }, [])

  return (
    <OffMarketGateContext.Provider value={{ requestAccess }}>
      {children}
      <OffMarketSignInModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </OffMarketGateContext.Provider>
  )
}
